<!-- Filtros y boton de filtros avanzados -->
<div
  fxLayout="row wrap"
  fxLayoutAlign="space-between center"
  class="top-panel-control content-body"
  fxLayoutGap="4px"
>
  <!-- Variedad==================== -->
  <mat-form-field
    fxFlex="17"
    fxFlex.sm="50"
    fxFlex.xs="100"
    appearance="outline"
  >
    <mat-label>Variedad</mat-label>
    <input
      type="text"
      placeholder="Seleccione uno..."
      matInput
      [formControl]="variety_control"
      [matAutocomplete]="auto1"
    />
    <button
      mat-button
      matSuffix
      *ngIf="!country_control.value"
      mat-icon-button
      class="mat-select-arrow-wrapper"
    >
      <div class="mat-select-arrow"></div>
    </button>
    <button
      mat-button
      *ngIf="variety_control.value"
      matSuffix
      mat-icon-button
      (click)="variety_control.setValue(''); fnSearchVariety()"
    >
      <mat-icon>close</mat-icon>
    </button>
    <mat-autocomplete
      autoActiveFirstOption
      #auto1="matAutocomplete"
      panelWidth="24em"
      (optionSelected)="fnSearchVariety()"
    >
      <mat-option
        *ngFor="let option of filteredOptionsVariety | async"
        [value]="option"
      >
        {{ option }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <!-- País==================== -->
  <mat-form-field
    fxFlex="17"
    fxFlex.sm="50"
    fxFlex.xs="100"
    appearance="outline"
    *ngIf="filteredOptionsCountry | async as countryList"
  >
    <mat-label>País</mat-label>
    <input
      type="text"
      placeholder="Seleccione uno..."
      matInput
      [formControl]="country_control"
      [matAutocomplete]="auto2"
    />
    <button
      mat-button
      matSuffix
      *ngIf="!country_control.value"
      mat-icon-button
      class="mat-select-arrow-wrapper"
    >
      <div class="mat-select-arrow"></div>
    </button>
    <button
      mat-button
      *ngIf="country_control.value"
      matSuffix
      mat-icon-button
      (click)="country_control.setValue(''); fnSearchVariety()"
    >
      <mat-icon>close</mat-icon>
    </button>
    <mat-autocomplete
      autoActiveFirstOption
      #auto2="matAutocomplete"
      panelWidth="12em"
      (optionSelected)="fnSearchVariety()"
    >
      <mat-option *ngFor="let option of countryList.data" [value]="option">
        {{ option }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <!-- Región==================== -->
  <mat-form-field
    fxFlex="17"
    fxFlex.sm="50"
    fxFlex.xs="100"
    appearance="outline"
    *ngIf="filteredOptionsRegion | async as regionList"
  >
    <mat-label>Región</mat-label>
    <input
      type="text"
      placeholder="Seleccione uno..."
      matInput
      [formControl]="region_control"
      [matAutocomplete]="auto3"
    />
    <button
      mat-button
      matSuffix
      *ngIf="!region_control.value"
      mat-icon-button
      class="mat-select-arrow-wrapper"
    >
      <div class="mat-select-arrow"></div>
    </button>
    <button
      mat-button
      *ngIf="region_control.value"
      matSuffix
      mat-icon-button
      (click)="region_control.setValue(''); fnSearchVariety()"
    >
      <mat-icon>close</mat-icon>
    </button>
    <mat-autocomplete
      autoActiveFirstOption
      #auto3="matAutocomplete"
      panelWidth="12em"
      (optionSelected)="fnSearchVariety()"
    >
      <mat-option *ngFor="let option of regionList.data" [value]="option">
        {{ option }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <!-- Grupo varietal==================== -->
  <mat-form-field
    fxFlex="17"
    fxFlex.sm="50"
    fxFlex.xs="100"
    appearance="outline"
    *ngIf="filteredOptionsVarietalGroup | async as varietalGroupList"
  >
    <mat-label>Grupo varietal</mat-label>
    <input
      type="text"
      placeholder="Seleccione uno..."
      matInput
      [formControl]="varietal_group_control"
      [matAutocomplete]="auto4"
    />
    <button
      mat-button
      matSuffix
      *ngIf="!varietal_group_control.value"
      mat-icon-button
      class="mat-select-arrow-wrapper"
    >
      <div class="mat-select-arrow"></div>
    </button>
    <button
      mat-button
      *ngIf="varietal_group_control.value"
      matSuffix
      mat-icon-button
      (click)="varietal_group_control.setValue(''); fnSearchVariety()"
    >
      <mat-icon>close</mat-icon>
    </button>
    <mat-autocomplete
      autoActiveFirstOption
      #auto4="matAutocomplete"
      panelWidth="12em"
      (optionSelected)="fnSearchVariety()"
    >
      <mat-option
        *ngFor="let option of varietalGroupList.data"
        [value]="option"
      >
        {{ option }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <!-- Users==================== -->
  <mat-form-field
    fxFlex="17"
    fxFlex.sm="50"
    fxFlex.xs="100"
    appearance="outline"
    *ngIf="userList"
  >
    <!-- *ngIf="filteredOptionsUser | async as userList" -->
    <mat-label>Tipo de organización</mat-label>
    <input
      type="text"
      placeholder="Seleccione uno..."
      matInput
      [formControl]="user_control"
      [matAutocomplete]="auto5"
    />
    <button
      mat-button
      matSuffix
      *ngIf="!user_control.value"
      mat-icon-button
      class="mat-select-arrow-wrapper"
    >
      <div class="mat-select-arrow"></div>
    </button>
    <button
      mat-button
      *ngIf="user_control.value"
      matSuffix
      mat-icon-button
      (click)="user_control.setValue(''); fnSearchVariety()"
    >
      <mat-icon>close</mat-icon>
    </button>
    <mat-autocomplete
      autoActiveFirstOption
      #auto5="matAutocomplete"
      panelWidth="30em"
      [displayWith]="displayFnUser"
      (optionSelected)="fnSearchVariety()"
    >
      <!-- <mat-option *ngFor="let option of userList.data" [value]="option">
        {{ option.username }}
      </mat-option> -->

      <mat-option *ngFor="let option of userList" [value]="option">
        {{ option.username }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <!-- ==================== -->
  <button
    fxFlex.xs="100"
    #bt
    mat-stroked-button=""
    (click)="fnGoAdvanceFilter()"
    matBadge="{{ matBadgeVarietyFilters }}"
    matBadgeColor="primary"
    style="background-color: #c4a1c0; color: #fff"
  >
    <mat-icon>tune</mat-icon> Filtros
  </button>
  <!-- ==================== -->
</div>

<!-- Banda informativa -->
<div
  fxLayout="row wrap"
  style="background-color: #c4a1c0"
  *ngIf="observationVarietyCounts | async as dataCounts"
>
  <div fxFlex="33" fxFlex.md="33" fxFlex.sm="50"></div>
  <!-- OBSERVACIONES -->
  <div
    fxFlex="12"
    fxFlex.md="12"
    fxFlex.sm="50"
    fxFlex.xs="100"
    style="
      padding: 0.5em;
      border-left: solid 2px #ffe39f;
      color: #fff;
      cursor: pointer;
    "
    (click)="fnGoToObservationView()"
  >
    <mat-icon>visibility</mat-icon>
    <span style="font-size: 2em; font-weight: 700">
      {{ dataCounts.data.observation_count }}
    </span>
    <span>OBSERVACIONES</span>
  </div>
  <!-- VARIEDADES -->
  <div
    fxFlex="12"
    fxFlex.md="12"
    fxFlex.sm="50"
    fxFlex.xs="100"
    style="padding: 0.5em; color: #fff; background-color: #e91e63"
  >
    <mat-icon>image</mat-icon>
    <span style="font-size: 2em; font-weight: 700"> {{ _length }} </span><br />
    <span>VARIEDADES</span>
  </div>
  <!-- OBSERVADORES -->
  <div
    fxFlex="12"
    fxFlex.md="12"
    fxFlex.sm="50"
    fxFlex.xs="100"
    style="border-right: solid 2px #ffe39f; padding: 0.5em; color: #fff"
  >
    <mat-icon>person</mat-icon>
    <span style="font-size: 2em; font-weight: 700">
      {{ dataCounts.data.observer_count }} </span
    ><br />
    <span>OBSERVADORES</span>
  </div>
  <!-- HOGARES -->
  <div
    fxFlex="12"
    fxFlex.md="12"
    fxFlex.sm="50"
    fxFlex.xs="100"
    style="border-right: solid 2px #ffe39f; padding: 0.5em; color: #fff"
  >
    <mat-icon>person</mat-icon>
    <span style="font-size: 2em; font-weight: 700">
      {{ dataCounts.data.farmer_count }} </span
    ><br />
    <span>HOGARES</span>
  </div>
</div>

<!-- Limpiador y paginador -->
<div
  fxLayout="row wrap"
  fxLayoutAlign="space-between center"
  class="content-body"
>
  <div fxFlex="55" fxFlex.sm="100%" fxFlex.xs="100%">
    <button
      mat-button
      color="warn"
      *ngIf="this.matBadgeVarietyFilters"
      (click)="fnClearFilters()"
    >
      <mat-icon>restart_alt</mat-icon> Limpiar filtros
    </button>
  </div>
  <div fxFlex="45" fxFlex.sm="100%" fxFlex.xs="100%">
    <mat-paginator
      [pageIndex]="page_control"
      [pageSize]="page_size_control"
      [length]="_length"
      [showFirstLastButtons]="_showFirstLastButtons"
      [pageSizeOptions]="_pageSizeOptions"
      (page)="handlePageEvent($event)"
      [style.background-color]="'#ffffff00'"
    >
    </mat-paginator>
  </div>
</div>

<!-- contenido variedades en cards -->
<div class="content content-body">
  <div fxLayout="row wrap" fxLayoutGap="32px grid">
    <div
      fxFlex="25%"
      fxFlex.sm="50%"
      fxFlex.xs="100%"
      *ngFor="let cardContent of cardContentList"
    >
      <app-template-card
        [cardContent]="cardContent"
        [route]="'catalogo-item'"
      ></app-template-card>
    </div>
  </div>
</div>

<!-- paginador final -->
<mat-paginator
  [pageIndex]="page_control"
  [pageSize]="page_size_control"
  [length]="_length"
  [showFirstLastButtons]="_showFirstLastButtons"
  [pageSizeOptions]="_pageSizeOptions"
  (page)="handlePageEvent($event)"
  [style.background-color]="'#ffffff00'"
  class="content-body"
>
</mat-paginator>
